import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { UserSidebarLoadAction } from '../../domains/userSidebarLoad/actions.types';

import type { UserSidebars } from './types';

export type UserSidebarAction = UserSidebarLoadAction;

const initialState: UserSidebars = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<UserSidebars, UserSidebarAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_SIDEBAR.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'USER_SIDEBAR.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'USER_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userSidebars);
    default:
      return state;
  }
};

export default reducer;
